import { isTermLessThanThirty } from 'Common/utilities/loanFundingDetails';

export default class LinkedTermDateCtrl {
  $onInit() {
    this.interestOnlyLoanTermList = this.termList.filter((term) =>
      isTermLessThanThirty(term),
    );
  }
}
